import React from 'react'
import styled from 'styled-components'

interface Props {
  connected: boolean
}

export const UserState = (props: Props) => {
  return <UserStateComponent $connected={props.connected} />
}

interface UserStateComponentProps {
  readonly $connected: boolean
}

const UserStateComponent = styled.div<UserStateComponentProps>`
  position: absolute;
  background: #${({ $connected }) => ($connected ? '39b54a' : 'f85359')};
  border: 2px white solid;
  width: 13px;
  height: 13px;
  border-radius: 100%;
  right: 0;
  bottom: 0;
`
